<template>
  <div class="container-onboarding-content">
    <div class="wrapper-title">
      <h3>
        <AnimatedGradientText>
          {{ t(`label_language_${languageSelectedLocal?.code}`) }}
        </AnimatedGradientText>
      </h3>
      <h4 class="medium">
        <AnimationTyping :text="t('please_select_language')" />
      </h4>
    </div>

    <SingleLanguageList class="fadeinOnboarding" :selected-language="languageSelectedLocal" @select="onSelect" />
  </div>
</template>

<script setup lang="ts">
import AnimationTyping from '@/components/animations/AnimationTyping.vue';
import SingleLanguageList from '@/components/domains/chat/chat-single/SingleLanguageList.vue';
import AnimatedGradientText from '@/components/shared/base/AnimatedGradientText.vue';
import { getLanguageByCode } from '@/static/languages';
import { useAudioStore } from '@/stores/audio';
import { useUserStore } from '@/stores/user';
import { Language } from '@/types/common';
import { ISelfServiceOnboardingForm } from '@/types/components';

const form = defineModel<ISelfServiceOnboardingForm>({
  required: true,
  default: () => ({}) as ISelfServiceOnboardingForm,
});

const { t } = useI18n();

const userStore = useUserStore();
const audioStore = useAudioStore();

const languageSelectedLocal = ref<Language | null>(null);

const onSelect = (language: Language) => {
  languageSelectedLocal.value = language;
  form.value.languageCode = language.code;
  audioStore.selectLanguage(language.code);
};

onMounted(() => {
  const language = getLanguageByCode(userStore.pageLanguage);

  form.value.languageCode = language.code;
  languageSelectedLocal.value = language;
});
</script>

<style scoped></style>
